import { useQuery } from 'react-query';
import { listReportRules } from '../services/reportRuleService';


export const useReportRules = () => {
  return useQuery('report-rules', listReportRules, {
    staleTime: 10,
    cacheTime: 10,
    refetchOnWindowFocus: false
  });
};